import { useState } from "react";
import { Link } from "react-router-dom";
import { PenLine, ShieldCheck } from "lucide-react";
import { useApi } from "../hooks/useApi";
import { Button } from "./ui/button";
import { DecisionDialog } from "./pipeline/Decision";

export function OtherApprovals({ items = [], onChange }) {
  const [dlg, setDlg] = useState(null);
  const { data: s } = useApi("/settings", { live: false });
  if (!items.length) return null;
  return (
    <section className="rise rounded-lg border-2 border-primary/30 bg-card overflow-hidden" data-testid="other-approvals-tray">
      <div className="flex items-center justify-between border-b px-4 sm:px-5 py-3"><h2 className="font-heading text-base font-bold">Partners, projects & signatures</h2><span className="font-figure text-xl font-bold" data-testid="other-approvals-count">{items.length}</span></div>
      <ul className="divide-y">{items.map((a) => (
        <li key={a.id} className="px-4 sm:px-5 py-4" data-testid={`other-item-${a.id}`}>
          <Link to={a.link} className="block">
            <div className="flex items-center gap-2 text-xs font-semibold text-muted-foreground">{a.type === "signature" ? <PenLine className="h-3.5 w-3.5" /> : <ShieldCheck className="h-3.5 w-3.5" />}{a.kind_label}</div>
            <div className="font-semibold">{a.title}</div>
            {a.summary && <div className="truncate text-sm text-muted-foreground">{a.summary[0]}</div>}
            {a.flags?.length > 0 && <div className="mt-1 text-xs font-semibold text-primary">{a.flags.join(" · ")}</div>}
          </Link>
          {a.type === "approval" ? <div className="mt-3 grid grid-cols-2 gap-2 sm:flex sm:justify-end">
            <Button variant="outline" className="h-11 sm:h-9" onClick={() => setDlg({ item: a, approve: false })} data-testid={`other-reject-${a.id}`}>Reject</Button>
            <Button className="h-11 sm:h-9 bg-[hsl(var(--positive))] hover:bg-[hsl(var(--positive)/0.9)]" onClick={() => setDlg({ item: a, approve: true })} data-testid={`other-approve-${a.id}`}>Approve</Button></div>
            : <div className="mt-3 sm:text-right"><Button asChild className="h-11 sm:h-9 w-full sm:w-auto"><Link to={a.link} data-testid={`other-sign-${a.id}`}>Open to sign</Link></Button></div>}
        </li>))}</ul>
      <DecisionDialog key={dlg?.item?.id + String(dlg?.approve)} item={dlg?.item} approve={dlg?.approve} ownerCodes={s?.owner_codes || []} onClose={() => setDlg(null)} onDone={onChange} />
    </section>
  );
}
